import { useOnlineVisitPriceWithVat } from '@/common/utils/onlineVisitPriceWithVat';
import { onlineVisitPriceLabel } from '@/modules/search/components/productCard/onlineVisitPrice';
import { corporateCardPrice } from '@/modules/corporate/livePrices';
import { useCorporateMember } from '@/modules/corporate/rollout';
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: sMdpLWyxbzDCruwMRffW2m
// Component: XhSI4pxMLR3L

import { pushSearchHistory } from "@/modules/search/functions/searchHistory";
import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { SideEffect } from "@plasmicpkgs/plasmic-basic-components";
import ProductCard from "../../ProductCard"; // plasmic-import: ZuA2HO8MLBhh/component
import Button from "../../Button"; // plasmic-import: oVzoHzMf1TLl/component
import ExternalBookSurveyPopup from "../../ExternalBookSurveyPopup"; // plasmic-import: YHypsyWp2tOf/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../fragment_design_system/plasmic.module.css"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/projectcss
import sty from "./PlasmicSearchResults.module.css"; // plasmic-import: XhSI4pxMLR3L/css

import Icon40Icon from "./icons/PlasmicIcon__Icon40"; // plasmic-import: g8tjAQ5z_ZU_/icon
import ChevronRightIcon from "../fragment_icons/icons/PlasmicIcon__ChevronRight"; // plasmic-import: GHdF3hS-oP_3/icon
import ChevronLeftIcon from "../fragment_icons/icons/PlasmicIcon__ChevronLeft"; // plasmic-import: r9Upp9NbiZkf/icon

import __fn_splunkEvent from "@/common/services/plasmicSplunkEvent"; // plasmic-import: splunkEvent/customFunction
// DR-07: impression predicate lives in src/ so it is unit-testable and reviewable.
// NOTE: this import is hand-added and a Plasmic re-sync will drop it — if the
// `search_top_suggested_card_view` event goes silent again, re-add it first.
import {
  buildTopSuggestedCardViewEvent,
  shouldSendTopSuggestedCardView
} from "@/common/services/topSuggestedCardView";
import { uniq as __lib_lodash__uniq } from "lodash";

createPlasmicElementProxy;

export type PlasmicSearchResults__VariantMembers = {
  isHorizental: "isHorizental";
};
export type PlasmicSearchResults__VariantsArgs = {
  isHorizental?: SingleBooleanChoiceArg<"isHorizental">;
};
type VariantPropType = keyof PlasmicSearchResults__VariantsArgs;
export const PlasmicSearchResults__VariantProps = new Array<VariantPropType>(
  "isHorizental"
);

export type PlasmicSearchResults__ArgsType = {
  searchResultResponse?: any;
  imageSrcPrefix?: string;
  nextPageTrigger?: () => void;
  paginationLoadingStatus?: boolean;
  location?: any;
  searchFooterSecondaryTasksObject?: any;
  searchFooterQuerySuggestionResponseObject?: any;
  showMyPerformanceMetricsBox?: any;
  topSuggestedCardFeature?: any;
  onlineVisitButtonsCustomDestination?: any;
  searchConsultResponse?: any;
  centerId?: string;
  onClick?: () => void;
};
type ArgPropType = keyof PlasmicSearchResults__ArgsType;
export const PlasmicSearchResults__ArgProps = new Array<ArgPropType>(
  "searchResultResponse",
  "imageSrcPrefix",
  "nextPageTrigger",
  "paginationLoadingStatus",
  "location",
  "searchFooterSecondaryTasksObject",
  "searchFooterQuerySuggestionResponseObject",
  "showMyPerformanceMetricsBox",
  "topSuggestedCardFeature",
  "onlineVisitButtonsCustomDestination",
  "searchConsultResponse",
  "centerId",
  "onClick"
);

export type PlasmicSearchResults__OverridesType = {
  root?: Flex__<"div">;
  setGrowthbookAttributes?: Flex__<typeof SideEffect>;
  showMySearchPerformance?: Flex__<"a"> & Partial<LinkProps>;
  topSuggestedCardVerticalStack?: Flex__<"div">;
  topSuggestedCard?: Flex__<typeof ProductCard>;
  resultCardsVerticalStack2?: Flex__<"div">;
  noItemFound?: Flex__<"div">;
  span?: Flex__<"span">;
  productCard?: Flex__<typeof ProductCard>;
  paginationMoreButton?: Flex__<typeof Button>;
  noResultsBlockVerticalStack?: Flex__<"div">;
  sideEffect?: Flex__<typeof SideEffect>;
  externalBookSurveyPopup?: Flex__<typeof ExternalBookSurveyPopup>;
};

export interface DefaultSearchResultsProps {
  searchResultResponse?: any;
  imageSrcPrefix?: string;
  nextPageTrigger?: () => void;
  paginationLoadingStatus?: boolean;
  location?: any;
  searchFooterSecondaryTasksObject?: any;
  searchFooterQuerySuggestionResponseObject?: any;
  showMyPerformanceMetricsBox?: any;
  topSuggestedCardFeature?: any;
  onlineVisitButtonsCustomDestination?: any;
  searchConsultResponse?: any;
  centerId?: string;
  onClick?: () => void;
  isHorizental?: SingleBooleanChoiceArg<"isHorizental">;
  className?: string;
}

const $$ = {
  splunkEvent: __fn_splunkEvent,
  lodash: {
    uniq: __lib_lodash__uniq
  }
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSearchResults__RenderFunc(props: {
  variants: PlasmicSearchResults__VariantsArgs;
  args: PlasmicSearchResults__ArgsType;
  overrides: PlasmicSearchResults__OverridesType;
  forNode?: string;
}) {
  // A/B: online-visit price shown with the invoice's 3% VAT for half the patients.
  const onlinePriceWithVat = useOnlineVisitPriceWithVat('search');
  // «ویزیت آنلاین سازمانی»: null for everyone but the one rolled-out account (corporate/rollout.ts)
  const corporateMember = useCorporateMember();
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          imageSrcPrefix: "https://cdn.paziresh24.com",
          paginationLoadingStatus: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const $globalActions = useGlobalActions?.();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "visibilityOfShowMySearchPerformance",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "isHorizental",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.isHorizental
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootisHorizental]: hasVariant(
            $state,
            "isHorizental",
            "isHorizental"
          )
        }
      )}
    >
      <SideEffect
        data-plasmic-name={"setGrowthbookAttributes"}
        data-plasmic-override={overrides.setGrowthbookAttributes}
        className={classNames("__wab_instance", sty.setGrowthbookAttributes)}
        deps={(() => {
          try {
            return [$ctx.Growthbook.isReady, $ctx.auth.info.id];
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        onMount={async () => {
          const $steps = {};

          $steps["setGrowthbookAttributes"] = $ctx.Growthbook.isReady
            ? (() => {
                const actionArgs = {
                  args: [
                    (() => {
                      try {
                        return {
                          ...$ctx.Growthbook.attributes,
                          url: window.location.href,
                          ...(Intl.DateTimeFormat().resolvedOptions()
                            .timeZone && {
                            timeZone:
                              Intl.DateTimeFormat().resolvedOptions().timeZone +
                              ","
                          }),
                          user_id: $ctx.auth?.info?.id
                        };
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return undefined;
                        }
                        throw e;
                      }
                    })()
                  ]
                };
                return $globalActions[
                  "GrowthbookGlobalContext.setAttributes"
                ]?.apply(null, [...actionArgs.args]);
              })()
            : undefined;
          if (
            $steps["setGrowthbookAttributes"] != null &&
            typeof $steps["setGrowthbookAttributes"] === "object" &&
            typeof $steps["setGrowthbookAttributes"].then === "function"
          ) {
            $steps["setGrowthbookAttributes"] =
              await $steps["setGrowthbookAttributes"];
          }
        }}
      />

      {(() => {
        try {
          return (
            !!globalThis.window?.user?.provider?.job_title &&
            $props.showMyPerformanceMetricsBox.enable
          );
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div className={classNames(projectcss.all, sty.freeBox___7EYwI)}>
          <PlasmicLink__
            data-plasmic-name={"showMySearchPerformance"}
            data-plasmic-override={overrides.showMySearchPerformance}
            className={classNames(
              projectcss.all,
              projectcss.a,
              projectcss.__wab_text,
              sty.showMySearchPerformance
            )}
            component={Link}
            href={(() => {
              try {
                return $props.showMyPerformanceMetricsBox.destination;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "";
                }
                throw e;
              }
            })()}
            platform={"nextjs"}
            target={"_blank"}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.showMyPerformanceMetricsBox.link_title;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "\u0645\u0634\u0627\u0647\u062f\u0647 \u0639\u0645\u0644\u06a9\u0631\u062f \u0634\u0645\u0627 \u062f\u0631 \u0646\u062a\u0627\u06cc\u062c \u062c\u0633\u062a\u062c\u0648\u0647\u0627\u06cc \u06a9\u0627\u0631\u0628\u0631\u0627\u0646 \u067e\u0630\u06cc\u0631\u063424";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </PlasmicLink__>
        </div>
      ) : null}
      {(() => {
        try {
          return $props.searchConsultResponse.search.result;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"topSuggestedCardVerticalStack"}
          data-plasmic-override={overrides.topSuggestedCardVerticalStack}
          className={classNames(
            projectcss.all,
            sty.topSuggestedCardVerticalStack
          )}
        >
          {(() => {
            try {
              return (
                $props.searchConsultResponse?.search?.result?.[0]?.title
                  ?.length >= 3 &&
                $props.searchConsultResponse.search.result[0].title !==
                  $props.searchResultResponse.search.result[0].title
              );
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <ProductCard
              data-plasmic-name={"topSuggestedCard"}
              data-plasmic-override={overrides.topSuggestedCard}
              actionButtons={(() => {
                try {
                  return (() => {
                    if (
                      typeof $ctx.Growthbook?.features?.["theme-config"]?.[
                        "search_result:show_first_free_time"
                      ] !== "undefined"
                    ) {
                      if (
                        !$ctx.Growthbook?.features?.["theme-config"]?.[
                          "search_result:show_first_free_time"
                        ]
                      ) {
                        $props.searchConsultResponse.search.result[0].actions =
                          $props.searchConsultResponse.search.result[0].actions.map(
                            action => ({
                              ...action,
                              top_title: ""
                            })
                          );
                      }
                      if (
                        $props.searchConsultResponse.search.result[0].actions[0]
                          ?.title === "ویزیت آنلاین" &&
                        $props.onlineVisitButtonsCustomDestination?.enable
                      ) {
                        $props.searchConsultResponse.search.result[0].actions[0].url =
                          $props.onlineVisitButtonsCustomDestination.url_template.replace(
                            "dr-slug-variable",
                            $props.searchConsultResponse.search.result[0].slug
                          );
                      }
                    }
                    return $props.searchConsultResponse.search.result[0]
                      .actions;
                  })();
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              address={(() => {
                try {
                  return $props.searchConsultResponse.search.result[0]
                    ?.display_address;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              avatarAltText={(() => {
                try {
                  return `${$props.searchConsultResponse.search.result[0].prefix ? $props.searchConsultResponse.search.result[0].prefix + " " : ""}${$props.searchConsultResponse.search.result[0].title ? $props.searchConsultResponse.search.result[0].title + " " : ""}${$props.searchConsultResponse.search.result[0].display_expertise ? $props.searchConsultResponse.search.result[0].display_expertise : ""}`;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              avatarRingColor={(() => {
                try {
                  return !$props.searchConsultResponse.search.result[0]
                    .is_bulk &&
                    $props.searchConsultResponse.search.result[0].is_bulk !==
                      undefined
                    ? "blue"
                    : undefined;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              avatarSrc={`${$props.imageSrcPrefix}${$props.searchConsultResponse.search.result[0]?.image}`}
              avatarVerifiedTick={(() => {
                try {
                  return (
                    !$props.searchConsultResponse.search.result[0].is_bulk &&
                    $props.searchConsultResponse.search.result[0].is_bulk !==
                      undefined
                  );
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })()}
              badges={(() => {
                try {
                  return (() => {
                    if (
                      typeof $ctx.Growthbook?.features?.["theme-config"]?.[
                        "search_result:show_available_time"
                      ] === "undefined"
                    ) {
                      return $props.searchConsultResponse.search.result[0]
                        .badges;
                    }
                    return $ctx.Growthbook?.features?.["theme-config"]?.[
                      "search_result:show_available_time"
                    ]
                      ? $props.searchConsultResponse.search.result[0].badges
                      : $props.searchConsultResponse.search.result[0].badges.filter(
                          badge => !badge.title.includes("فعال شدن نوبت")
                        );
                  })();
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              certificates={(() => {
                try {
                  return $props.searchConsultResponse.search.result[0]?.expertises
                    ? {
                        expertises:
                          $props.searchConsultResponse.search.result[0].expertises
                      }
                    : {};
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              className={classNames("__wab_instance", sty.topSuggestedCard)}
              eventTrigger={async (elementName, elementContent) => {
                const $steps = {};

                $steps["clickEvent"] = true
                  ? (() => {
                      const actionArgs = {
                        args: [
                          (() => {
                            try {
                              return {
                                group: "search_metrics",
                                type: "search_top_suggested_card_click",
                                data: {
                                  card_data: {
                                    action:
                                      $props?.searchConsultResponse?.search?.result?.[0].actions?.map?.(
                                        item =>
                                          JSON.stringify({
                                            outline: item.outline,
                                            title: item.title,
                                            top_title: item.top_title.replace(
                                              /(<([^>]+)>)/gi,
                                              ""
                                            )
                                          })
                                      ),
                                    _id: $props?.searchConsultResponse?.search
                                      ?.result?.[0]._id,
                                    server_id:
                                      $props?.searchConsultResponse?.search
                                        ?.result?.[0].server_id,
                                    title:
                                      $props?.searchConsultResponse?.search
                                        ?.result?.[0].title,
                                    type: $props?.searchConsultResponse?.search
                                      ?.result?.[0].type,
                                    url: $props?.searchConsultResponse?.search
                                      ?.result?.[0].url,
                                    rates_count:
                                      $props?.searchConsultResponse?.search
                                        ?.result?.[0].rates_count,
                                    satisfaction:
                                      $props?.searchConsultResponse?.search
                                        ?.result?.[0].satisfaction
                                  },
                                  filters:
                                    $props.searchResultResponse
                                      .selected_filters,
                                  result_count:
                                    $props.searchResultResponse?.search?.result
                                      ?.length,
                                  location: $props.location.city_name,
                                  city_id: $props.location.city_id,
                                  lat: $props.location.lat,
                                  lon: $props.location.lon,
                                  query_id:
                                    $props.searchResultResponse.search.query_id
                                }
                              };
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()
                        ]
                      };
                      return $globalActions["Splunk.sendLog"]?.apply(null, [
                        ...actionArgs.args
                      ]);
                    })()
                  : undefined;
                if (
                  $steps["clickEvent"] != null &&
                  typeof $steps["clickEvent"] === "object" &&
                  typeof $steps["clickEvent"].then === "function"
                ) {
                  $steps["clickEvent"] = await $steps["clickEvent"];
                }

                $steps["runCodeSplunkEvent"] = false
                  ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return $$.splunkEvent({
                            token: "7c4a4dbb-0abc-4d1f-8e65-fbd7e52debbd",
                            group: "search_metrics",
                            type: "search_top_suggested_card_click",
                            data: {
                              card_data: {
                                action:
                                  $props.searchConsultResponse.search.result[0].actions?.map?.(
                                    item =>
                                      JSON.stringify({
                                        outline: item.outline,
                                        title: item.title,
                                        top_title: item.top_title.replace(
                                          /(<([^>]+)>)/gi,
                                          ""
                                        )
                                      })
                                  ),
                                online_visit_buttons_custom_destination:
                                  $props.onlineVisitButtonsCustomDestination &&
                                  $props.onlineVisitButtonsCustomDestination
                                    .enable
                                    ? $props.onlineVisitButtonsCustomDestination
                                        .url_template
                                    : undefined,
                                _id: $props.searchConsultResponse.search
                                  .result[0]._id,
                                position:
                                  $props.searchConsultResponse.search.result[0]
                                    .position,
                                server_id:
                                  $props.searchConsultResponse.search.result[0]
                                    .server_id,
                                title:
                                  $props.searchConsultResponse.search.result[0]
                                    .title,
                                type: $props.searchConsultResponse.search
                                  .result[0].type,
                                url: $props.searchConsultResponse.search
                                  .result[0].url,
                                rates_count:
                                  $props.searchConsultResponse.search.result[0]
                                    .rates_count,
                                satisfaction:
                                  $props.searchConsultResponse.search.result[0]
                                    .satisfaction
                              },
                              filters:
                                $props.searchResultResponse.selected_filters,
                              result_count: $props.searchResultResponse.lent,
                              location: $props.location.city_name,
                              city_id: $props.location.city_id,
                              lat: $props.location.lat,
                              lon: $props.location.lon,
                              query_id:
                                $props.searchResultResponse.search.query_id
                            }
                          });
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runCodeSplunkEvent"] != null &&
                  typeof $steps["runCodeSplunkEvent"] === "object" &&
                  typeof $steps["runCodeSplunkEvent"].then === "function"
                ) {
                  $steps["runCodeSplunkEvent"] =
                    await $steps["runCodeSplunkEvent"];
                }
              }}
              externalBookDesign={(() => {
                try {
                  return $ctx.Growthbook.features[
                    "search-card-externalbook-variant"
                  ];
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return [];
                  }
                  throw e;
                }
              })()}
              price={(() => {
                try {
                  return corporateCardPrice(onlineVisitPriceLabel($props.searchConsultResponse.search.result[0], onlinePriceWithVat), $props.searchConsultResponse.search.result[0], onlinePriceWithVat, corporateMember);
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              rateCount={(() => {
                try {
                  return $props.searchConsultResponse.search.result[0]
                    .rates_count;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              satisfactionPercent={(() => {
                try {
                  return $props.searchConsultResponse.search.result[0]
                    .satisfaction;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              subTitle={(() => {
                try {
                  return $props.searchConsultResponse.search.result[0]
                    ?.display_expertise;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              title={(() => {
                try {
                  return $props.searchConsultResponse.search.result[0]?.title;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              topBadge={(() => {
                try {
                  return [
                    {
                      title: "پیشنهاد ویزیت آنلاین پذیرش24",
                      description: "",
                      type: "success"
                    }
                  ];
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return [{ title: "", description: "", type: "success" }];
                  }
                  throw e;
                }
              })()}
              url={(() => {
                try {
                  return {
                    destination:
                      $props.searchConsultResponse.search.result[0].url,
                    title: `${$props.searchConsultResponse.search.result[0].prefix ? $props.searchConsultResponse.search.result[0].prefix + " " : ""}${$props.searchConsultResponse.search.result[0].title ? $props.searchConsultResponse.search.result[0].title + " " : ""}${$props.searchConsultResponse.search.result[0].display_expertise ? $props.searchConsultResponse.search.result[0].display_expertise : ""}`
                  };
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            />
          ) : null}
        </div>
      ) : null}
      {(() => {
        try {
          return $props.searchResultResponse.search.result.length !== 0;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"resultCardsVerticalStack2"}
          data-plasmic-override={overrides.resultCardsVerticalStack2}
          className={classNames(projectcss.all, sty.resultCardsVerticalStack2, {
            [sty.resultCardsVerticalStack2isHorizental]: hasVariant(
              $state,
              "isHorizental",
              "isHorizental"
            )
          })}
        >
          {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
            (() => {
              try {
                return (() => {
                  // DR-07 §13 condition 3/M-8: insert position now comes from the backend
                  // (`promoted_online_visit.display_index`, carried through as
                  // `searchConsultResponse.display_index`) instead of a hardcoded 3, so it can be
                  // tuned server-side without an app deploy. Falls back to 3 (today's behavior) when
                  // absent, so old backends/flag-off responses render byte-identical.
                  const __displayIndex =
                    $props?.searchConsultResponse?.display_index ?? 3;
                  const result = [
                    ...$props?.searchResultResponse?.search?.result?.slice(
                      0,
                      __displayIndex
                    ),
                    $props?.searchConsultResponse?.search?.result?.[1]
                      ? {
                          ...$props?.searchConsultResponse?.search?.result?.[1],
                          topSuggestedCardFeature:
                            $props.topSuggestedCardFeature
                        }
                      : null,
                    ...$props?.searchResultResponse?.search?.result?.slice(
                      __displayIndex
                    )
                  ]?.filter(Boolean);
                  const firstMatchIndex = result.findIndex(item =>
                    item?.topSuggestedCardFeature?.enable ||
                    !item?.centers ||
                    !$props?.location?.name
                      ? false
                      : !item?.centers
                          ?.filter?.(center => center.id != "5532")
                          ?.some?.(
                            center =>
                              center?.city_name === $props?.location?.name
                          )
                  );
                  const newList = result.map((item, index) => {
                    if (index === firstMatchIndex && $props.location.id != -1) {
                      return {
                        ...item,
                        outside_of_location: true
                      };
                    }
                    return {
                      ...item,
                      otside_of_location: false
                    };
                  });
                  return newList;
                })();
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()
          ).map((__plasmic_item_0, __plasmic_idx_0) => {
            const currentItem = __plasmic_item_0;
            const currentIndex = __plasmic_idx_0;
            return (
              <div
                className={classNames(projectcss.all, sty.freeBox__a25Zy, {
                  [sty.freeBoxisHorizental__a25ZysX3UT]: hasVariant(
                    $state,
                    "isHorizental",
                    "isHorizental"
                  )
                })}
                key={(() => {
                  try {
                    return currentItem._id;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              >
                {(() => {
                  try {
                    return (
                      currentItem.outside_of_location &&
                      !window.location.href.includes("turn_type=consult")
                    );
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return false;
                    }
                    throw e;
                  }
                })() ? (
                  <div
                    data-plasmic-name={"noItemFound"}
                    data-plasmic-override={overrides.noItemFound}
                    className={classNames(projectcss.all, sty.noItemFound)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__apXlz)}
                    >
                      <Icon40Icon
                        className={classNames(projectcss.all, sty.svg__gd1Tp)}
                        role={"img"}
                      />

                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__d3Bmq
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {
                              "\u0646\u062a\u06cc\u062c\u0647 \u062f\u06cc\u06af\u0631\u06cc \u0645\u0631\u062a\u0628\u0637 \u0628\u0627 \u062c\u0633\u062a\u062c\u0648\u06cc \u0634\u0645\u0627 \u062f\u0631 "
                            }
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <span
                              data-plasmic-name={"span"}
                              data-plasmic-override={overrides.span}
                              className={classNames(
                                projectcss.all,
                                projectcss.span,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.span
                              )}
                            >
                              <React.Fragment>
                                {(() => {
                                  try {
                                    return $props.location.name;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "-";
                                    }
                                    throw e;
                                  }
                                })()}
                              </React.Fragment>
                            </span>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {" \u067e\u06cc\u062f\u0627 \u0646\u0634\u062f."}
                          </span>
                          <React.Fragment>{"\n"}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {" "}
                          </span>
                          <React.Fragment>
                            {
                              "\n\u062f\u0631 \u0627\u062f\u0627\u0645\u0647 \u0645\u06cc\u200c\u062a\u0648\u0627\u0646\u06cc\u062f \u0627\u0632 \u0628\u06cc\u0646 \u0646\u062a\u0627\u06cc\u062c \u0633\u0627\u06cc\u0631 \u0645\u0646\u0627\u0637\u0642 \u0627\u0646\u062a\u062e\u0627\u0628 \u06a9\u0646\u06cc\u062f.\n"
                            }
                          </React.Fragment>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                ) : null}
                <ProductCard
                  data-plasmic-name={"productCard"}
                  data-plasmic-override={overrides.productCard}
                  _5StarRatingMode3={undefined}
                  actionButtons={(() => {
                    try {
                      return (() => {
                        if (!$ctx.Growthbook?.isReady) {
                          return currentItem.actions;
                        }
                        const showFirstFreeTimeFeature =
                          $ctx.Growthbook?.features?.["theme-config"]?.[
                            "search_result:show_first_free_time"
                          ];
                        if (
                          typeof showFirstFreeTimeFeature !== "undefined" &&
                          !showFirstFreeTimeFeature
                        ) {
                          currentItem.actions = currentItem.actions.map(
                            action => ({
                              ...action,
                              top_title: ""
                            })
                          );
                        }
                        if (currentItem.actions[0]?.title === "ویزیت آنلاین") {
                          const oldUrl = currentItem.actions[0].url || "";
                          const match = oldUrl.match(/serviceId=([^&]+)/);
                          const serviceId = match ? match[1] : null;
                          if (serviceId) {
                            currentItem.actions[0].url = `https://www.paziresh24.com/factor/v2/${currentItem.slug}/${serviceId}/`;
                          }
                        }
                        if ($props.centerId) {
                          return currentItem.actions.map(item => ({
                            ...item,
                            url:
                              item.url.replace("/dr/", "/booking/") +
                              `?centerId=${$props.centerId}`
                          }));
                        }
                        return currentItem.actions;
                      })();
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  address={(() => {
                    try {
                      return currentItem.display_address;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  avatarAltText={(() => {
                    try {
                      return `${currentItem.prefix ? currentItem.prefix + " " : ""}${currentItem.title ? currentItem.title + " " : ""}${currentItem.display_expertise ? currentItem.display_expertise : ""}`;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  avatarRingColor={(() => {
                    try {
                      return !currentItem.is_bulk &&
                        currentItem.is_bulk !== undefined
                        ? "blue"
                        : undefined;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  avatarSrc={(() => {
                    try {
                      return currentItem.image === undefined ||
                        currentItem.image === ""
                        ? undefined
                        : currentItem.image.startsWith("https")
                          ? currentItem.image
                          : $props.imageSrcPrefix + currentItem.image;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  avatarVerifiedTick={(() => {
                    try {
                      return (
                        !currentItem.is_bulk &&
                        currentItem.is_bulk !== undefined
                      );
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return false;
                      }
                      throw e;
                    }
                  })()}
                  badges={(() => {
                    try {
                      return (() => {
                        if (
                          typeof $ctx.Growthbook?.features?.["theme-config"]?.[
                            "search_result:show_available_time"
                          ] === "undefined"
                        ) {
                          return currentItem.badges;
                        }
                        return $ctx.Growthbook?.features?.["theme-config"]?.[
                          "search_result:show_available_time"
                        ]
                          ? currentItem.badges
                          : currentItem.badges.filter(
                              badge => !badge.title.includes("فعال شدن نوبت")
                            );
                      })();
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  centers={(() => {
                    try {
                      return currentItem.centers;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  certificates={(() => {
                    try {
                      return currentItem.expertises
                        ? { expertises: currentItem.expertises }
                        : {};
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  className={classNames("__wab_instance", sty.productCard, {
                    [sty.productCardisHorizental]: hasVariant(
                      $state,
                      "isHorizental",
                      "isHorizental"
                    )
                  })}
                  classificationTitleApi={`https://apigw.paziresh24.com/v1/jahannama/classifications/${currentItem._id}`}
                  debugModeResult={(() => {
                    try {
                      return $props.searchResultResponse.debug_mode_result.search_engine_response.entity.results.find(
                        result => result.documentId === currentItem._id
                      );
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  eventTrigger={async (elementName, elementContent) => {
                    const $steps = {};

                    // DR-07 §13/M-5 (docs/dev-requests/dr-07-online-visit-suggestion-to-backend.md):
                    // the injected index-3 card (`currentItem.is_promoted`, stamped by
                    // src/modules/search/hooks/useSearch.ts off `promoted_online_visit.is_promoted`)
                    // must NOT fire `search_click_position` — it is not an organic result and its
                    // `position` field is meaningless for this item. It fires the dedicated
                    // `search_top_suggested_card_click` event below instead (own step).
                    $steps["sendSplunkClickEvent"] = !currentItem?.is_promoted
                      ? (() => {
                          const actionArgs = {
                            args: [
                              (() => {
                                try {
                                  return {
                                    event_group: "search_metrics",
                                    event_type: "search_click_position",
                                    url: {
                                      href: window.location?.href ?? "",
                                      query: window.location?.search ?? "",
                                      pathname: window.location?.pathname ?? "",
                                      host: window.location?.host ?? ""
                                    },
                                    suggestion_source: (function () {
                                      if (
                                        $props &&
                                        typeof $props.searchResultResponse
                                          .search.suggestion_source !==
                                          "undefined"
                                      ) {
                                        return $props.searchResultResponse
                                          .search.suggestion_source;
                                      }
                                      return false;
                                    })(),
                                    semantic_search:
                                      $props?.searchResultResponse?.search
                                        ?.semantic_search &&
                                      $props.searchResultResponse.search
                                        .semantic_search == "true"
                                        ? "true"
                                        : "false",
                                    userAgent:
                                      globalThis.navigator.userAgent > 3
                                        ? globalThis.navigator.userAgent
                                        : "",
                                    card_data: {
                                      action:
                                        currentItem?.actions?.map?.(item =>
                                          JSON.stringify({
                                            outline: item?.outline ?? "",
                                            title: item?.title ?? "",
                                            top_title:
                                              item?.top_title?.replace(
                                                /(<([^>]+)>)/gi,
                                                ""
                                              ) ?? ""
                                          })
                                        ) ?? [],
                                      online_visit_buttons_custom_destination:
                                        $props
                                          ?.onlineVisitButtonsCustomDestination
                                          ?.enable
                                          ? $props
                                              .onlineVisitButtonsCustomDestination
                                              .url_template
                                          : undefined,
                                      _id: currentItem?._id ?? "",
                                      position: currentItem?.position ?? "",
                                      server_id: currentItem?.server_id ?? "",
                                      title: currentItem?.title ?? "",
                                      type: currentItem?.type ?? "",
                                      url: currentItem?.url ?? "",
                                      rates_count:
                                        currentItem?.rates_count ?? 0,
                                      satisfaction:
                                        currentItem?.satisfaction ?? 0
                                    },
                                    filters:
                                      $props?.searchResultResponse
                                        ?.selected_filters ?? [],
                                    result_count:
                                      $props?.searchResultResponse?.lent ?? 0,
                                    location: $props?.location?.city_name ?? "",
                                    city_id: $props?.location?.city_id ?? "",
                                    lat: $props?.location?.lat ?? 0,
                                    lon: $props?.location?.lon ?? 0,
                                    elementName:
                                      typeof elementName !== "undefined"
                                        ? elementName
                                        : "",
                                    elementContent:
                                      typeof elementContent !== "undefined"
                                        ? elementContent?.replace("risman_", "")
                                        : "",
                                    query_id:
                                      $props?.searchResultResponse?.search
                                        ?.query_id ?? "",
                                    is_risman:
                                      elementContent.includes("risman_"),
                                    terminal_id: (function () {
                                      try {
                                        return document.cookie.replace(
                                          /(?:(?:^|.*;\s*)terminal_id\s*\=\s*([^;]*).*$)|^.*$/,
                                          "$1"
                                        );
                                      } catch (e) {
                                        return null;
                                      }
                                    })(),
                                    query_attributes: $props
                                      .searchResultResponse.query_attributes
                                      ? $props.searchResultResponse
                                          .query_attributes
                                      : undefined
                                  };
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()
                            ]
                          };
                          return $globalActions["Splunk.sendLog"]?.apply(null, [
                            ...actionArgs.args
                          ]);
                        })()
                      : undefined;
                    if (
                      $steps["sendSplunkClickEvent"] != null &&
                      typeof $steps["sendSplunkClickEvent"] === "object" &&
                      typeof $steps["sendSplunkClickEvent"].then === "function"
                    ) {
                      $steps["sendSplunkClickEvent"] =
                        await $steps["sendSplunkClickEvent"];
                    }

                    // DR-07 §13/Q-B/M-5: dedicated click event for the promoted card, same
                    // group/type/payload shape as the banner's clickEvent above (:566-641) so the two
                    // "promoted-card click" surfaces stay consistent for Splunk analysis.
                    $steps["sendPromotedCardClickEvent"] = currentItem?.is_promoted
                      ? (() => {
                          const actionArgs = {
                            args: [
                              (() => {
                                try {
                                  return {
                                    group: "search_metrics",
                                    type: "search_top_suggested_card_click",
                                    data: {
                                      card_data: {
                                        action:
                                          currentItem?.actions?.map?.(
                                            item =>
                                              JSON.stringify({
                                                outline: item.outline,
                                                title: item.title,
                                                top_title: item.top_title.replace(
                                                  /(<([^>]+)>)/gi,
                                                  ""
                                                )
                                              })
                                          ),
                                        _id: currentItem?._id,
                                        server_id: currentItem?.server_id,
                                        title: currentItem?.title,
                                        type: currentItem?.type,
                                        url: currentItem?.url,
                                        rates_count: currentItem?.rates_count,
                                        satisfaction: currentItem?.satisfaction
                                      },
                                      filters:
                                        $props.searchResultResponse
                                          .selected_filters,
                                      result_count:
                                        $props.searchResultResponse?.search
                                          ?.result?.length,
                                      location: $props.location.city_name,
                                      city_id: $props.location.city_id,
                                      lat: $props.location.lat,
                                      lon: $props.location.lon,
                                      query_id:
                                        $props.searchResultResponse.search
                                          .query_id
                                    }
                                  };
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()
                            ]
                          };
                          return $globalActions["Splunk.sendLog"]?.apply(null, [
                            ...actionArgs.args
                          ]);
                        })()
                      : undefined;
                    if (
                      $steps["sendPromotedCardClickEvent"] != null &&
                      typeof $steps["sendPromotedCardClickEvent"] ===
                        "object" &&
                      typeof $steps["sendPromotedCardClickEvent"].then ===
                        "function"
                    ) {
                      $steps["sendPromotedCardClickEvent"] =
                        await $steps["sendPromotedCardClickEvent"];
                    }

                    $steps["runCodeSv2CtrRequest"] = false
                      ? (() => {
                          const actionArgs = {
                            customFunction: async () => {
                              return fetch(
                                "https://www.paziresh24.com/api/sv2ctr",
                                {
                                  headers: {
                                    accept: "application/json, text/plain, */*",
                                    "accept-language": "fa",
                                    "content-type": "application/json",
                                    "sec-fetch-dest": "empty",
                                    "sec-fetch-mode": "cors",
                                    "sec-fetch-site": "same-origin"
                                  },
                                  body: JSON.stringify({
                                    terminal_id: document.cookie
                                      .split("; ")
                                      .find(row =>
                                        row.startsWith("terminal_id")
                                      )
                                      ? document.cookie
                                          .split("; ")
                                          .find(row =>
                                            row.startsWith("terminal_id")
                                          )
                                          .split("=")[1]
                                      : "sample-empty-terminal-id-cookie",
                                    id: currentItem._id,
                                    position: currentItem.position,
                                    query_id:
                                      $props.searchResultResponse.search
                                        .query_id,
                                    server_id: currentItem.server_id,
                                    type: currentItem.type
                                  }),
                                  method: "POST",
                                  credentials: "include"
                                }
                              );
                            }
                          };
                          return (({ customFunction }) => {
                            return customFunction();
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["runCodeSv2CtrRequest"] != null &&
                      typeof $steps["runCodeSv2CtrRequest"] === "object" &&
                      typeof $steps["runCodeSv2CtrRequest"].then === "function"
                    ) {
                      $steps["runCodeSv2CtrRequest"] =
                        await $steps["runCodeSv2CtrRequest"];
                    }

                    $steps["setHistoryKeyword"] = true
                      ? (() => {
                          const actionArgs = {
                            customFunction: async () => {
                              return pushSearchHistory(currentItem?.title ?? "");
                            }
                          };
                          return (({ customFunction }) => {
                            return customFunction();
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["setHistoryKeyword"] != null &&
                      typeof $steps["setHistoryKeyword"] === "object" &&
                      typeof $steps["setHistoryKeyword"].then === "function"
                    ) {
                      $steps["setHistoryKeyword"] =
                        await $steps["setHistoryKeyword"];
                    }

                    $steps["runOnClick"] = true
                      ? (() => {
                          const actionArgs = { eventRef: $props["onClick"] };
                          return (({ eventRef, args }) => {
                            return eventRef?.(...(args ?? []));
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["runOnClick"] != null &&
                      typeof $steps["runOnClick"] === "object" &&
                      typeof $steps["runOnClick"].then === "function"
                    ) {
                      $steps["runOnClick"] = await $steps["runOnClick"];
                    }
                  }}
                  externalBookDesign={(() => {
                    try {
                      return $ctx.Growthbook.features[
                        "search-card-externalbook-variant"
                      ];
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  externalLinkTitle={(() => {
                    try {
                      return currentItem.slug
                        .split("uri=https%3A%2F%2F")[1]
                        ?.split?.("%2F")?.[0]?.length > 2
                        ? "نوبت‌دهی در " +
                            (currentItem.slug
                              .split("uri=https%3A%2F%2F")[1]
                              ?.split?.("%2F")[0] === "drdr.ir"
                              ? "دکتردکتر"
                              : currentItem.slug
                                  .split("uri=https%3A%2F%2F")[1]
                                  ?.split?.("%2F")?.[0])
                        : "";
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  keywordTags={(() => {
                    try {
                      return {
                        user_priority_1:
                          currentItem?.keyword_tags_user_priority_1 ?? []
                      };
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  price={(() => {
                    try {
                      return corporateCardPrice(onlineVisitPriceLabel(currentItem, onlinePriceWithVat), currentItem, onlinePriceWithVat, corporateMember);
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  rateCount={(() => {
                    try {
                      return (() => {
                        if (
                          currentItem.rates_count !== undefined &&
                          (!$ctx.Growthbook ||
                            !$ctx.Growthbook.isReady ||
                            !$ctx.Growthbook.attributes?.url ||
                            Object.keys($ctx.Growthbook.features).length == 0 ||
                            ($ctx.Growthbook.features?.["theme-config"] &&
                              $ctx.Growthbook.features["theme-config"]?.[
                                "search_result:show_rate_and_reviews"
                              ]))
                        ) {
                          return currentItem.rates_count;
                        } else {
                          return 0;
                        }
                      })();
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  recordType={(() => {
                    try {
                      return currentItem.record_type;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  satisfactionPercent={(() => {
                    try {
                      return (() => {
                        if (
                          currentItem.satisfaction !== undefined &&
                          (!$ctx.Growthbook ||
                            !$ctx.Growthbook.isReady ||
                            !$ctx.Growthbook.attributes?.url ||
                            Object.keys($ctx.Growthbook.features).length == 0 ||
                            ($ctx.Growthbook.features?.["theme-config"] &&
                              $ctx.Growthbook.features["theme-config"]?.[
                                "search_result:show_rate_and_reviews"
                              ]))
                        ) {
                          return currentItem.satisfaction;
                        } else {
                          return 0;
                        }
                      })();
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  searchCardId={(() => {
                    try {
                      return currentItem._id;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  slug={(() => {
                    try {
                      return currentItem.slug;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  subTitle={(() => {
                    try {
                      return (
                        currentItem.display_expertise ||
                        currentItem.subtitle ||
                        ""
                      );
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  title={(() => {
                    try {
                      return currentItem.title;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  topBadge={(() => {
                    try {
                      return [
                        {
                          title: currentItem.topSuggestedCardFeature.badge_lable
                            ? currentItem.topSuggestedCardFeature.badge_lable
                            : null,
                          description: "",
                          type: "success"
                        }
                      ];
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  url={(() => {
                    try {
                      return {
                        destination: currentItem.url,
                        title: `${currentItem.prefix ? currentItem.prefix + " " : ""}${currentItem.title ? currentItem.title + " " : ""}${currentItem.display_expertise ? currentItem.display_expertise : ""}`
                      };
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      {(() => {
        try {
          return $props.searchResultResponse.search.pagination.limit === 0
            ? false
            : $props.searchResultResponse.search.pagination.limit *
                $props.searchResultResponse.search.pagination.page <
                $props.searchResultResponse.search.total;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <Button
          data-plasmic-name={"paginationMoreButton"}
          data-plasmic-override={overrides.paginationMoreButton}
          children2={
            "\u0646\u0645\u0627\u06cc\u0634 \u0646\u062a\u0627\u06cc\u062c \u0628\u06cc\u0634\u062a\u0631 ..."
          }
          className={classNames("__wab_instance", sty.paginationMoreButton)}
          endIcon={
            <ChevronLeftIcon
              className={classNames(projectcss.all, sty.svg__steSm)}
              role={"img"}
            />
          }
          loading={(() => {
            try {
              return $props.paginationLoadingStatus;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return [];
              }
              throw e;
            }
          })()}
          onClick={async event => {
            const $steps = {};

            $steps["runNextPageTrigger"] = true
              ? (() => {
                  const actionArgs = { eventRef: $props["nextPageTrigger"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runNextPageTrigger"] != null &&
              typeof $steps["runNextPageTrigger"] === "object" &&
              typeof $steps["runNextPageTrigger"].then === "function"
            ) {
              $steps["runNextPageTrigger"] = await $steps["runNextPageTrigger"];
            }
          }}
          outline={true}
          startIcon={
            <ChevronRightIcon
              className={classNames(projectcss.all, sty.svg__eDvlU)}
              role={"img"}
            />
          }
        />
      ) : null}
      {(() => {
        try {
          return $props?.searchResultResponse?.search?.total === 0;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"noResultsBlockVerticalStack"}
          data-plasmic-override={overrides.noResultsBlockVerticalStack}
          className={classNames(
            projectcss.all,
            sty.noResultsBlockVerticalStack
          )}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__psRc
            )}
          >
            {
              "\u0646\u062a\u06cc\u062c\u0647 \u0627\u06cc \u0645\u0631\u062a\u0628\u0637 \u0628\u0627 \u062c\u0633\u062a\u062c\u0648\u06cc \u0634\u0645\u0627 \u067e\u06cc\u062f\u0627 \u0646\u06a9\u0631\u062f\u06cc\u0645."
            }
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__fjxY
            )}
          >
            {
              "\u062c\u0633\u062a\u062c\u0648\u06cc \u062e\u0648\u062f \u0631\u0627 \u0628\u0647\u062a\u0631 \u06a9\u0646\u06cc\u062f:"
            }
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__bUp8Z
            )}
          >
            <React.Fragment>
              <React.Fragment>{""}</React.Fragment>
              {
                <ul
                  className={classNames(
                    projectcss.all,
                    projectcss.ul,
                    sty.ul__u9LlH
                  )}
                >
                  <li
                    className={classNames(
                      projectcss.all,
                      projectcss.li,
                      projectcss.__wab_text,
                      sty.li__oRdjU
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{""}</React.Fragment>
                      {
                        <ul
                          className={classNames(
                            projectcss.all,
                            projectcss.ul,
                            sty.ul__qa1Fo
                          )}
                        >
                          <li
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.li__tpsj
                            )}
                          >
                            {
                              "\u0639\u0628\u0627\u0631\u0627\u062a \u06a9\u0627\u0645\u0644 \u062a\u0631\u06cc \u0631\u0627 \u0628\u0631\u0627\u06cc \u0646\u062a\u06cc\u062c\u0647 \u0645\u0648\u0631\u062f \u0646\u0638\u0631\u062a\u0627\u0646 \u0648\u0627\u0631\u062f \u06a9\u0646\u06cc\u062f."
                            }
                          </li>
                          <li
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.li___23Bw6
                            )}
                          >
                            {
                              "\u0627\u06af\u0631 \u0628\u0647 \u062f\u0646\u0628\u0627\u0644 \u067e\u0632\u0634\u06a9 \u06cc\u0627 \u0645\u0631\u06a9\u0632 \u062f\u0631\u0645\u0627\u0646\u06cc \u062e\u0627\u0635\u06cc \u0647\u0633\u062a\u06cc\u062f \u0646\u0627\u0645 \u0631\u0633\u0645\u06cc \u0648 \u0635\u062d\u06cc\u062d \u0622\u0646 \u0631\u0627 \u0628\u0646\u0648\u06cc\u0633\u06cc\u062f."
                            }
                          </li>
                          <li
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.li__m1Gqu
                            )}
                          >
                            <React.Fragment>
                              <React.Fragment>{"\u0628\u0627 "}</React.Fragment>
                              {
                                <PlasmicLink__
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.a,
                                    projectcss.__wab_text,
                                    projectcss.plasmic_default__inline,
                                    sty.link__fJLrZ
                                  )}
                                  component={Link}
                                  platform={"nextjs"}
                                >
                                  {
                                    "\u062f\u06a9\u062a\u0631\u0647\u0627\u06cc \u0622\u0646\u0644\u0627\u06cc\u0646 \u067e\u0630\u06cc\u0631\u063424"
                                  }
                                </PlasmicLink__>
                              }
                              <React.Fragment>
                                {
                                  "\u060c \u0647\u0645\u06cc\u0646 \u0627\u0644\u0627\u0646 \u06af\u0641\u062a\u06af\u0648 \u06a9\u0646\u06cc\u062f. ("
                                }
                              </React.Fragment>
                              {
                                <PlasmicLink__
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.a,
                                    projectcss.__wab_text,
                                    projectcss.plasmic_default__inline,
                                    sty.link__g6E8A
                                  )}
                                  component={Link}
                                  platform={"nextjs"}
                                >
                                  {
                                    "\u0645\u0634\u0627\u0647\u062f\u0647 \u062f\u0633\u062a\u0647\u200c\u0647\u0627"
                                  }
                                </PlasmicLink__>
                              }
                              <React.Fragment>{")"}</React.Fragment>
                            </React.Fragment>
                          </li>
                        </ul>
                      }
                      <React.Fragment>{""}</React.Fragment>
                    </React.Fragment>
                  </li>
                </ul>
              }
              <React.Fragment>{""}</React.Fragment>
            </React.Fragment>
          </div>
        </div>
      ) : null}
      <SideEffect
        data-plasmic-name={"sideEffect"}
        data-plasmic-override={overrides.sideEffect}
        className={classNames("__wab_instance", sty.sideEffect)}
        onMount={async () => {
          const $steps = {};

          $steps["sendClarityCustomTagsEventRunCode"] = true
            ? (() => {
                const actionArgs = {
                  customFunction: async () => {
                    return (() => {
                      try {
                        clarity(
                          "set",
                          "fragment_component_load",
                          "search results"
                        );
                        return console.log(
                          "try to set clarity tag fragment_component_load to search results"
                        );
                      } catch (error) {
                        return console.error(error);
                      }
                    })();
                  }
                };
                return (({ customFunction }) => {
                  return customFunction();
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["sendClarityCustomTagsEventRunCode"] != null &&
            typeof $steps["sendClarityCustomTagsEventRunCode"] === "object" &&
            typeof $steps["sendClarityCustomTagsEventRunCode"].then ===
              "function"
          ) {
            $steps["sendClarityCustomTagsEventRunCode"] =
              await $steps["sendClarityCustomTagsEventRunCode"];
          }

          $steps["topSuggestedCardViewSplunkEvent"] = true
            ? (() => {
                const actionArgs = {
                  customFunction: async () => {
                    return setTimeout(() => {
                      if (
                        shouldSendTopSuggestedCardView(
                          $props.searchConsultResponse,
                          $props.searchResultResponse
                        )
                      ) {
                        // Must go through the SAME channel as the click event
                        // (`Splunk.sendLog`, :641). The `$$.splunkEvent` helper
                        // defaults to https://p24splk.paziresh24.com with token
                        // 7c4a4dbb…, which never lands in `p24_search_events_b` —
                        // that is why the sibling click emitter at :654 is
                        // permanently gated `false`. Using it here made the view
                        // event fire client-side but never arrive.
                        $globalActions["Splunk.sendLog"]?.(
                          buildTopSuggestedCardViewEvent(
                            $props.searchResultResponse,
                            $props.location
                          )
                        );
                      }
                    }, 2000);
                  }
                };
                return (({ customFunction }) => {
                  return customFunction();
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["topSuggestedCardViewSplunkEvent"] != null &&
            typeof $steps["topSuggestedCardViewSplunkEvent"] === "object" &&
            typeof $steps["topSuggestedCardViewSplunkEvent"].then === "function"
          ) {
            $steps["topSuggestedCardViewSplunkEvent"] =
              await $steps["topSuggestedCardViewSplunkEvent"];
          }

          $steps["visibleShowMySearchPerformanceVisibilityByFetchUrl"] = false
            ? (() => {
                const actionArgs = {
                  customFunction: async () => {
                    return fetch(
                      "https://api.paziresh24.com/V1/doctor/profile",
                      { credentials: "include" }
                    )
                      .then(response => {
                        if (!response.ok) {
                          throw new Error("Network response was not ok");
                        }
                        return response.json();
                      })
                      .then(data => {
                        console.log(data);
                        if (data.data.id) {
                          $state.visibilityOfShowMySearchPerformance = true;
                          console.log(
                            "Visibility of Show My Search Performance:",
                            $state.visibilityOfShowMySearchPerformance
                          );
                        }
                      })
                      .catch(error => {
                        console.error("Fetch error:", error);
                      });
                  }
                };
                return (({ customFunction }) => {
                  return customFunction();
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["visibleShowMySearchPerformanceVisibilityByFetchUrl"] !=
              null &&
            typeof $steps[
              "visibleShowMySearchPerformanceVisibilityByFetchUrl"
            ] === "object" &&
            typeof $steps["visibleShowMySearchPerformanceVisibilityByFetchUrl"]
              .then === "function"
          ) {
            $steps["visibleShowMySearchPerformanceVisibilityByFetchUrl"] =
              await $steps[
                "visibleShowMySearchPerformanceVisibilityByFetchUrl"
              ];
          }
        }}
      />

      {(() => {
        try {
          return $ctx.Growthbook.features["search-external-book-survey-popup"];
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <ExternalBookSurveyPopup
          data-plasmic-name={"externalBookSurveyPopup"}
          data-plasmic-override={overrides.externalBookSurveyPopup}
          className={classNames("__wab_instance", sty.externalBookSurveyPopup)}
        />
      ) : null}
      <div className={classNames(projectcss.all, sty.freeBox__knrNp)} />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "setGrowthbookAttributes",
    "showMySearchPerformance",
    "topSuggestedCardVerticalStack",
    "topSuggestedCard",
    "resultCardsVerticalStack2",
    "noItemFound",
    "span",
    "productCard",
    "paginationMoreButton",
    "noResultsBlockVerticalStack",
    "sideEffect",
    "externalBookSurveyPopup"
  ],
  setGrowthbookAttributes: ["setGrowthbookAttributes"],
  showMySearchPerformance: ["showMySearchPerformance"],
  topSuggestedCardVerticalStack: [
    "topSuggestedCardVerticalStack",
    "topSuggestedCard"
  ],
  topSuggestedCard: ["topSuggestedCard"],
  resultCardsVerticalStack2: [
    "resultCardsVerticalStack2",
    "noItemFound",
    "span",
    "productCard"
  ],
  noItemFound: ["noItemFound", "span"],
  span: ["span"],
  productCard: ["productCard"],
  paginationMoreButton: ["paginationMoreButton"],
  noResultsBlockVerticalStack: ["noResultsBlockVerticalStack"],
  sideEffect: ["sideEffect"],
  externalBookSurveyPopup: ["externalBookSurveyPopup"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  setGrowthbookAttributes: typeof SideEffect;
  showMySearchPerformance: "a";
  topSuggestedCardVerticalStack: "div";
  topSuggestedCard: typeof ProductCard;
  resultCardsVerticalStack2: "div";
  noItemFound: "div";
  span: "span";
  productCard: typeof ProductCard;
  paginationMoreButton: typeof Button;
  noResultsBlockVerticalStack: "div";
  sideEffect: typeof SideEffect;
  externalBookSurveyPopup: typeof ExternalBookSurveyPopup;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSearchResults__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSearchResults__VariantsArgs;
    args?: PlasmicSearchResults__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSearchResults__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSearchResults__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSearchResults__ArgProps,
          internalVariantPropNames: PlasmicSearchResults__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSearchResults__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSearchResults";
  } else {
    func.displayName = `PlasmicSearchResults.${nodeName}`;
  }
  return func;
}

export const PlasmicSearchResults = Object.assign(
  // Top-level PlasmicSearchResults renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    setGrowthbookAttributes: makeNodeComponent("setGrowthbookAttributes"),
    showMySearchPerformance: makeNodeComponent("showMySearchPerformance"),
    topSuggestedCardVerticalStack: makeNodeComponent(
      "topSuggestedCardVerticalStack"
    ),
    topSuggestedCard: makeNodeComponent("topSuggestedCard"),
    resultCardsVerticalStack2: makeNodeComponent("resultCardsVerticalStack2"),
    noItemFound: makeNodeComponent("noItemFound"),
    span: makeNodeComponent("span"),
    productCard: makeNodeComponent("productCard"),
    paginationMoreButton: makeNodeComponent("paginationMoreButton"),
    noResultsBlockVerticalStack: makeNodeComponent(
      "noResultsBlockVerticalStack"
    ),
    sideEffect: makeNodeComponent("sideEffect"),
    externalBookSurveyPopup: makeNodeComponent("externalBookSurveyPopup"),

    // Metadata about props expected for PlasmicSearchResults
    internalVariantProps: PlasmicSearchResults__VariantProps,
    internalArgProps: PlasmicSearchResults__ArgProps
  }
);

export default PlasmicSearchResults;
/* prettier-ignore-end */
